import { Box, styled } from '@mui/material';

const FullScreenBackground = styled(Box)({
  display: 'flex',
  height: '100vh',
  backgroundImage: 'url("/images/backGround.png")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
});

const LeftSpacer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  height: '100%',
});

const RightSpacer = styled(Box)({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'white',
  flexDirection: 'column',
  gap: '48px',
});

const ContentBox = styled(Box)({
  width: 400,
  color: 'black',
  textAlign: 'center',
});

export { ContentBox, FullScreenBackground, LeftSpacer, RightSpacer };
